var map = {
	"./customer-bg.webp": 1492,
	"./customer-img.webp": 1493,
	"./dice-img.webp": 1494,
	"./games-img.webp": 1495,
	"./lc-img.webp": 1496,
	"./lottery-img.webp": 1497,
	"./mission-bg.webp": 1498,
	"./mission-img-2.webp": 1499,
	"./mission-img.webp": 1500,
	"./mission-main-bg.webp": 1501,
	"./mobile-bg.webp": 1502,
	"./p2p-img.webp": 1503,
	"./product-bg.webp": 1504,
	"./product-main-bg.webp": 1505,
	"./sb-provider.webp": 1506,
	"./sbo-provider.webp": 1507,
	"./side-bar-bg.webp": 1508,
	"./slot-img.webp": 1509,
	"./spade-img.webp": 1510,
	"./sport-img.webp": 1511
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 208;